import React from 'react';

const DAYS = [
    { key: 'sun', label: 'Sun' },
    { key: 'mon', label: 'Mon' },
    { key: 'tue', label: 'Tue' },
    { key: 'wed', label: 'Wed' },
    { key: 'thu', label: 'Thu' },
    { key: 'fri', label: 'Fri' },
    { key: 'sat', label: 'Sat' },
];

interface DayOfWeekSelectorProps {
    selectedDays: string[];
    onDaysChange: (days: string[]) => void;
}

const DayOfWeekSelector: React.FC<DayOfWeekSelectorProps> = ({ selectedDays, onDaysChange }) => {
    const handleCheckboxChange = (dayKey: string) => {
        const newSelectedDays = selectedDays.includes(dayKey)
            ? selectedDays.filter(d => d !== dayKey)
            : [...selectedDays, dayKey];
        onDaysChange(newSelectedDays);
    };

    return (
        <div className="d-flex align-items-center">
            <span className="me-3 fw-medium text-muted small">Days:</span>
            <div className="d-flex gap-3 flex-wrap">
                {DAYS.map(day => (
                    <div className="form-check" key={day.key}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`day-check-${day.key}`}
                            checked={selectedDays.includes(day.key)}
                            onChange={() => handleCheckboxChange(day.key)}
                        />
                        <label className="form-check-label" htmlFor={`day-check-${day.key}`}>
                            {day.label}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DayOfWeekSelector;